module.exports = __webpack_public_path__ + "img/Icon-ClosingDownloadBot.20e9bab4.svg";